import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './base-query';

const profileAPI = createApi({
    reducerPath: 'profileAPI',
    baseQuery,
    tagTypes: ['profile'],
    endpoints: (builder) => ({
        getProfileDetails: builder.query({
            query: () => {
                return {
                    url: '/api/v1/staff/profile',
                    method: 'GET'
                };
            },
            providesTags: ['profile'],
        }),

        updateProfile: builder.mutation({
            query: ({ payload }) => ({
                url: `/api/v1/staff/profile`,
                method: 'PATCH',
                body: payload,
            }),
            invalidatesTags: ['profile'],
        })
    })
});

export const {
    useGetProfileDetailsQuery,
    useLazyGetProfileDetailsQuery,
    useUpdateProfileMutation
} = profileAPI;

export default profileAPI;